export * from "./cape.svg";
export * from "./wings.svg";

export const z = 0;
